import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["deploymentOrganization"]

  connect() {
    $(this.deploymentOrganizationTarget).select2({ placeholder: "Select an organization" })
  }
}
